import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { useLang } from "@/context/LanguageContext";

import { ArrowLeft, MapPin, Clock, Wind, CheckCircle, AlertTriangle, ExternalLink } from "lucide-react";

import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import BookingForm from "@/components/BookingForm";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import FAQSection from "@/components/FAQSection";




export default function Caraguatatuba() {


const { setLang } = useLang(); // pegue o setter do seu contexto
/*
  useEffect(() => {
    setLang("pt"); // força pt só nesta página, ao montar
  }, [setLang]);
*/

  useEffect(() => {

    

    
  //t.useLang = 'pt'; // Força o idioma para português, pois esta página é específica para Caraguatatuba
setLang("pt");


    window.scrollTo(0, 0);
    document.title = "Voo Livre de Parapente em Caraguatatuba | Litoral Norte SP";
    
    // Configuração da Meta Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content", 
      "Agende seu voo duplo de parapente em Caraguatatuba 350,00 inclui fotos. Decolagens do Morro Santo Antônio e Praia Martim de Sá com vista para Ilhabela e São Sebastião."
    );

    // Remove qualquer schema JSON-LD anterior para garantir que só fique o atual
    document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
      script.remove();
    });

    // Configuração dos Schemas SEO (JSON-LD) com 3 produtos adicionados
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": "https://paraglidetour.com/caraguatatuba",
          "name": "Parapente Litoral",
          "telephone": "+5512982131757",
          "url": "https://paraglidetour.com/caraguatatuba",
          "image": "https://form-assets.mailchimp.com/images/accounts/248431004/348a55ea089957e4f14b45ebd5f26e4c.webp",
          "sameAs": [
            "https://www.instagram.com/paraglidingeveryday/",
            "https://www.instagram.com/parapentelitoral/",
            "https://www.youtube.com/@paraglidingeveryday",
            "https://www.tiktok.com/@parapente.litoral"
          ],
          "priceRange": "R$ 250,00 - R$ 399,00",
          
          "hasMap": "https://maps.app.goo.gl/5gz7gXTAXWi6rziaA",
          
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Praia Martim de Sá - Caraguatatuba",
            "addressRegion": "SP",
            "addressCountry": "BR"
          }
        
        },
        // Produto 1: Voo Morro Santo Antônio
        {
          "@type": "Product",
          "name": "Voo de Parapente no Morro Santo Antônio - Caraguatatuba",
          "description": "Voo duplo morro santo antonio 6x sem juros. Um voo contemplativo incrível com o visual completo da baía de Caraguatatuba e montanhas.",
          "url": "https://paraglidetour.com/tours/voo_morro_santo_antonio",
          "image": "https://ik.imagekit.io/paraglidetour/parapenteverticalmcvl.png",
          "provider": {
            "@id": "https://paraglidetour.com/caraguatatuba/",
            "name": "Parapente Vertical"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "BRL",
            "price": "320.00",
            "availability": "https://schema.org/InStock",
            "url": "https://paraglidetour.com/tours/voo-morro-santo-antonio",
            "image": "https://ik.imagekit.io/paraglidetour/parapenteverticalmcvl.png",
            "validFrom": "2026-01-01T08:00:00+00:00",
            "priceValidUntil": "2026-11-30T23:59:59+00:00",
            "priceSpecification": {
              "@type": "UnitPriceSpecification",
              "priceType": "https://schema.org/StrikethroughPrice",
              "price": "380.00",
              "priceCurrency":  "BRL",
            },

          }
        },
        // Produto 2: Voo Praia Martim de Sá
        {
          "@type": "Product",
          "name": "Voo de Parapente na Praia Martim de Sá  - Caraguatatuba",
          "description": "Voo de parapente na praia 300,00 com fotos e filmagem. Um voo sobrevoando as águas cristalinas de uma das praias mais famosas do Litoral Norte.",
          "url": "https://paraglidetour.com/tours/voo_livre_caraguatatuba",
          "provider": {
            "@id": "https://paraglidetour.com/parapentecaraguatatuba/",
            "name": "Parapente Caraguá"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "BRL",
            "price": "299.00",
            "availability": "https://schema.org/InStock",
            "url": "https://paraglidetour.com/tours/voo_livre_caraguatatuba",
            "validFrom": "2026-01-01T08:00:00+00:00",
            "priceValidUntil": "2026-11-30T23:59:59+00:00",
            "priceSpecification": {
              "@type": "UnitPriceSpecification",
              "priceType": "https://schema.org/StrikethroughPrice",
              "price": "350.00",
              "priceCurrency":  "BRL",
            },
          }
        },
        // Produto 3: Voo Praia Martim de Sá VIP
        {
          "@type": "Product",
          "name": "Voo de Parapente Praia Martim de Sá VIP - Caraguatatuba",
          "description": "A experiência definitiva. 30 minutos de voo ou seu dinheiro de volta. O dobro de tempo no ar para você aproveitar cada segundo sobrevoando o mar e a orla completa.",
          "url": "https://paraglidetour.com/tours/praia_martim_de_sa_vip",
          "image": "https://form-assets.mailchimp.com/images/accounts/248431004/348a55ea089957e4f14b45ebd5f26e4c.webp",
          "provider": {
            "@id": "https://paraglidetour.com/caraguatatuba/",
            "name": "Parapente Litoral"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "BRL",
            "price": "350.00",
            "availability": "https://schema.org/InStock",
            "url": "https://paraglidetour.com/tours/praia_martim_de_sa_vip",
            "validFrom": "2026-01-01T08:00:00+00:00",
            "priceValidUntil": "2026-11-30T23:59:59+00:00",
            "priceSpecification": {
              "@type": "UnitPriceSpecification",
              "priceType": "https://schema.org/StrikethroughPrice",
              "price": "400.00",
              "priceCurrency":  "BRL",
            },
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Como garantir um voo de parapente seguro e evitar acidentes?",
              "text": "Como garantir um voo de parapente seguro e evitar acidentes?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Contrate seu passeio online e receba as informações do seu instrutor por e-mail.  EXIJA SEMPRE que o piloto apresente a licença de INSTRUTOR e Voo duplo válida com foto. Sempre que possível, consulte o nome do piloto online no sistema da CBVL (https://sistema.cbvl.com.br/piloto/piloto-consulta) para evitar golpistas e piratas."
              }
            }
          ]
        }
      ]
    };

    const scriptSchema = document.createElement('script');
    scriptSchema.setAttribute('id', 'seo-schema');
    scriptSchema.setAttribute('type', 'application/ld+json');
    scriptSchema.textContent = JSON.stringify(schemaData);
    document.head.appendChild(scriptSchema);

    return () => {
      if (scriptSchema && scriptSchema.parentNode) {
        scriptSchema.parentNode.removeChild(scriptSchema);
      }
    };
  }, [setLang]);

  return (
    <div className="min-h-screen bg-sand text-jungle">
      <Header />
      {/* {<TrustBar />} */}

      {/* Seção de Introdução SEO com Imagem de Fundo */}
      <section 
        className="pt-20 pb-16 relative bg-cover bg-center border-b border-jungle/10"
        style={{ backgroundImage: `url('https://images.unsplash.com/photo-1592208128295-5aaa34f1d72b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000')` }}
      >
        <div className="absolute inset-0 bg-jungle/75"></div>

        <div className="max-w-5xl mx-auto px-6 md:px-12 text-center relative z-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-overline text-[10px] text-zinc-800 hover:text-zinc-950 transition-colors mb-6"
          >
            <ArrowLeft size={14} /> VOLTAR PARA A PÁGINA INICIAL
          </Link>
          <div className="font-overline text-terracotta text-xs mb-3">Aventura no Litoral Norte</div>
          <h1 className="font-display text-4xl md:text-5xl text-zinc-900 leading-tight mb-6">
            Voo Livre de Parapente em Caraguatatuba
          </h1>
          <p className="text-zinc-800 text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
            Descubra a emoção do <strong className="text-zinc-950">parapente em Caraguá</strong>. O <strong className="text-zinc-950">voo livre em Caraguatatuba</strong> é a experiência definitiva para quem busca adrenalina e contato com a natureza no <strong className="text-zinc-950">Litoral Norte</strong> de São Paulo. Sobrevoe a <strong className="text-zinc-950">praia</strong> e desfrute de uma vista panorâmica inesquecível que se estende até <strong className="text-zinc-950">Ilhabela</strong> e <strong className="text-zinc-950">São Sebastião</strong>.
          </p>
        </div>
      </section>

      {/* Seção de Pacotes de Voo (3 Opções) */}
      <section className="pt-16 md:pt-24 pb-8 bg-sand">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl text-jungle mb-4">
              Escolha o seu Roteiro de Voo
            </h2>
            <p className="text-forest text-lg">
              Opções exclusivas com decolagens nos melhores picos da região.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Voo Morro Santo Antônio */}
            <article className="bg-white rounded-2xl border border-jungle/15 shadow-sm hover:shadow-lg transition-shadow relative overflow-hidden flex flex-col">
              
              <img 
                src="https://ik.imagekit.io/paraglidetour/morro-santo-antonio.jpg" 
                alt="Voo no Morro Santo Antônio" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-3 mb-4 text-terracotta">
                  <MapPin size={24} />
                  <h3 className="font-display text-2xl text-jungle">Morro Santo Antônio</h3>
                </div>
                <p className="text-forest mb-6 flex-grow">
                  A decolagem clássica da região. Um voo contemplativo incrível com o visual completo da baía de Caraguatatuba e montanhas.
                </p>
                
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center gap-2 text-forest">
                    <Clock size={18} className="text-terracotta" />
                    <span>Duração do voo: <strong>5 a 15 minutos</strong></span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <Wind size={18} className="text-terracotta" />
                    <span>Decolagem: 325m de altitude</span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <CheckCircle size={18} className="text-jungle" />
                    <span>Instrução inclusa</span>
                  </li>
                </ul>
            <div className="flex flex-col gap-2 items-start">
                                      <Link to="/tandem/morro_santo_antonio" data-testid="package-details-btn-morro_santo_antonio" className="btn-primary text-center justify-center font-overline text-[20px] text-center justify-center text-terracotta hover:text-forest transition-colors">
                                        Detalhes →
                                      </Link>
                                     
                              </div>

                <div className="border-t border-jungle/10 pt-6 mt-auto">
                  <div className="flex flex-col mb-4">
                    <span className="line-through text-forest/70 text-sm font-medium">De R$ 420,00</span>
                    <span className="font-display text-4xl text-jungle">R$ 400<span className="text-xl">,00</span></span>
                  </div>
                  <a href="/#book" className="btn-primary w-full text-center justify-center">
                    Agendar Voo Clássico
                  </a>
                </div>
              </div>
            </article>

            {/* Voo Praia Martim de Sá (Padrão) */}
            <article className="bg-white rounded-2xl border border-jungle/15 shadow-sm hover:shadow-lg transition-shadow relative overflow-hidden flex flex-col">
              <div className="absolute top-0 right-0 bg-terracotta text-white font-overline text-[10px] px-3 py-1 rounded-bl-lg z-10">
                MAIS POPULAR
              </div>             
              <img 
                src="https://ik.imagekit.io/paraglidetour/parapente-caraguatatuba1.jpg" 
                alt="Voo na Praia Martim de Sá" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-3 mb-4 text-terracotta">
                  <MapPin size={24} />
                  <h3 className="font-display text-2xl text-jungle">Praia Martim de Sá</h3>
                </div>
                <p className="text-forest mb-6 flex-grow">
                  Sinta a brisa do mar. Um voo sobrevoando as águas cristalinas de uma das praias mais famosas do Litoral Norte.
                </p>
                
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center gap-2 text-forest">
                    <Clock size={18} className="text-terracotta" />
                    <span>Duração do voo: <strong>15 a 20 minutos</strong></span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <Wind size={18} className="text-terracotta" />
                    <span>Visual do litoral</span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <CheckCircle size={18} className="text-jungle" />
                    <span>Instrução inclusa</span>
                  </li>
                </ul>

                <div className="flex flex-col gap-2 items-start">
                                      <Link to="/tandem/parapente_caraguatatuba" data-testid="package-details-btn-parapente_caraguatatuba" className="btn-primary text-center justify-center font-overline text-[20px] text-center justify-center text-terracotta hover:text-forest transition-colors">
                                        Detalhes →
                                      </Link>
                                     
                              </div>

                <div className="border-t border-jungle/10 pt-6 mt-auto">
                  <div className="flex flex-col mb-4">
                    <span className="line-through text-forest/70 text-sm font-medium">De R$ 400,00</span>
                    <span className="font-display text-4xl text-jungle">R$ 350<span className="text-xl">,00</span></span>
                  </div>
                  <a href="/#book" className="btn-primary w-full text-center justify-center">
                    Agendar Voo Litoral
                  </a>
                </div>
              </div>
            </article>

            {/* Voo Praia Martim de Sá VIP */}
            <article className="bg-white rounded-2xl border border-jungle/15 shadow-sm hover:shadow-lg transition-shadow relative overflow-hidden flex flex-col">
              <div className="absolute top-0 right-0 bg-jungle text-white font-overline text-[10px] px-3 py-1 rounded-bl-lg z-10">
                VIP / EXCLUSIVO
              </div>
              <img 
                src="https://ik.imagekit.io/paraglidetour/parapente-caraguatatuba2.jpg" 
                alt="Voo VIP na Praia Martim de Sá" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-3 mb-4 text-terracotta">
                  <MapPin size={24} />
                  <h3 className="font-display text-2xl text-jungle">Praia Martim de Sá VIP</h3>
                </div>
                <p className="text-forest mb-6 flex-grow">
                  A experiência definitiva. O dobro de tempo no ar para você aproveitar cada segundo sobrevoando o mar e a orla completa.
                </p>
                
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center gap-2 text-forest">
                    <Clock size={18} className="text-terracotta" />
                    <span>Duração do voo: <strong>20 a 30 minutos garantidos</strong></span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <Wind size={18} className="text-terracotta" />
                    <span>Voo estendido exclusivo</span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <CheckCircle size={18} className="text-jungle" />
                    <span>Instrução inclusa</span>
                  </li>
                </ul>
                  <div className="flex flex-col gap-2 items-start">
                                      <Link to="/tandem/parapente_litoral" data-testid="package-details-btn-parapente_litoral" className="btn-primary text-center justify-center font-overline text-[20px] text-center justify-center text-terracotta hover:text-forest transition-colors">
                                        Detalhes →
                                      </Link>
                                     
                              </div>

                <div className="border-t border-jungle/10 pt-6 mt-auto">
                  <div className="flex flex-col mb-4">
                    <span className="line-through text-forest/70 text-sm font-medium">De R$ 450,00</span>
                    <span className="font-display text-4xl text-jungle">R$ 400<span className="text-xl">,00</span></span>
                  </div>
                  <a href="/#book" className="btn-primary w-full text-center justify-center">
                    Agendar Voo VIP
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* Seção de Aviso de Segurança Contra Piratas */}
      <section className="pb-16 md:pb-24 bg-sand">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="bg-white border-l-4 border-terracotta rounded-r-2xl p-6 md:p-8 shadow-sm flex flex-col md:flex-row gap-6 items-start md:items-center">
            <div className="bg-terracotta/10 p-4 rounded-full flex-shrink-0">
              <AlertTriangle className="text-terracotta" size={32} />
            </div>
            <div>
              <h3 className="font-display text-2xl text-jungle mb-3">Aviso Importante: Segurança em Primeiro Lugar</h3>
              <p className="text-forest text-base leading-relaxed mb-4">
                Para garantir um passeio seguro e divertido, é fundamental evitar amadores, golpistas e operadores piratas. <br /> Não sirva de cobaia <strong>EXIJA SEMPRE</strong> que o piloto apresente a <strong>licença de INSTRUTOR + Voo Duplo válida e com foto</strong> antes da sua decolagem.
              </p>
              <a 
                href="https://sistema.cbvl.com.br/piloto/piloto-consulta" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-terracotta font-bold hover:text-jungle transition-colors text-sm md:text-base"
              >
                Consultar licença do piloto online na CBVL <ExternalLink size={18} />
              </a>
            </div>
          </div>
        </div>
      </section>
      
      <Gallery />

      <Testimonials />
    
      <Footer />
    </div>
  );
}